function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import CalendarLocale from '@cloud-sn/v-datepicker/es/locale/zh_CN';
import DateFnsLocale from 'date-fns/locale/zh_cn';
export default {
  lang: _objectSpread({
    WeekLocale: {
      weekStartsOn: 1,

      /* Monday */
      firstWeekContainsDate: 4
    },
    // 与 date-fns的locale对应
    DateFnsLocale: DateFnsLocale,
    placeholder: '请选择日期',
    multiPlaceholder: '请选择一个或多个日期',
    monthPlaceholder: '请选择月份',
    yearPlaceholder: '请选择年',
    weekPlaceholder: '请选择周',
    weekFormat: 'YYYY 第 WW 周',
    rangePlaceholder: ['开始日期', '结束日期'],
    rangeMonthPlaceholder: ['开始月份', '结束月份'],
    rangeYearPlaceholder: ['开始年份', '结束年份']
  }, CalendarLocale)
};